export default __webpack_public_path__ + "33e65f5.png";